<div class="cv-photo-card-container">
	<div class="card">
		<div class="card-header">

			<div class="card-image" (click)="openBig()">
				<div class="background" 
					[ngClass]="{ 'loaded ': !loadingPhoto }"
					[ngStyle]="{'background-image': 'url(' + info.thumbnails[0] + ')'}">
				</div>
				<!-- <div class="foreground">
					<img [src]="info.path" (load)="onImageLoad($event)">
				</div>
				
				<div *ngIf="loadingPhoto" class="loading-wrapper">
					<i class="fas fa-spinner"></i>
				</div> -->
			</div>

			<!-- <div class="card-image">
				<ngx-gallery
					[options]="galleryOptions"
					[images]="images"
					(previewOpen)="onPreviewOpen()"
					(previewClose)="onPreviewClose()"
				></ngx-gallery>
			</div> -->

			<div
				*ngIf="isEditing"
				class="check-main"
				[ngStyle]="{ 'z-index': zIndex }"
				(click)="selectPhoto()"
			>
				<i
					[ngClass]="{
						'fas fa-check-square': isSelected,
						'far fa-square': !isSelected
					}"
				></i>
			</div>
			<ng-container *ngIf="options?.showPrimary !== false">
				<div *ngIf="isEditing" class="header-sub-title">
					<a (click)="setAsMainPhoto()">
						<i
							[ngClass]="{
								'far ': !info.metadata.isPrimary,
								'fas ': info.metadata.isPrimary,
								'fa-bookmark': true
							}"
						></i>
					</a>
					<label>Mark as primary photo</label>
				</div>
				<div *ngIf="!isEditing" class="header-sub-title">
					<span class="primary-holder">
						<i
							[ngClass]="{
								'far ': !info.metadata.isPrimary,
								'fas ': info.metadata.isPrimary,
								'fa-bookmark': true
							}"
						></i>
					</span>
					<label>
						<span *ngIf="info.metadata.isPrimary">Primary photo</span>
						<span *ngIf="!info.metadata.isPrimary">&nbsp;</span>
					</label>
				</div>
			</ng-container>
		</div>
		<div class="card-body">
			<div class="description-content">
				<!-- <p>Location</p>
				<label>{{ address }}</label> -->
				<a (click)="hideMap()">
					{{ isDisplayingMap ? 'Hide' : 'Show' }} Map
					<i
						[ngClass]="{
							'far fa-eye-slash': isDisplayingMap,
							'fas fa-eye': !isDisplayingMap
						}"
					></i>
				</a>
			</div>

			<div class="map-container" *ngIf="isDisplayingMap">
				<!-- 
					Google map image, instead the actual map-->
				<img
					(click)="openMap()"class="img-fluid"
					src="https://maps.googleapis.com/maps/api/staticmap?zoom=19&size=640x400&markers=color:red%7C{{
						info.metadata.latitude
					}},{{ info.metadata.longitude }}&key={{ gKey }}"
				/>
				<!-- -->
				<!-- <agm-map
					#agmMap
					[latitude]="mapCord.lat"
					[longitude]="mapCord.long"
					[mapDraggable]="false"
					[zoom]="15"
				>
					<agm-marker [latitude]="mapCord.lat" [longitude]="mapCord.long"></agm-marker>
				</agm-map> -->
			</div>
		</div>
	</div>
</div>
